"use strict";
exports.__esModule = true;
exports.TX_STATUS = void 0;
exports.TX_STATUS = {
    NOT_FOUND: "Transaction not found",
    NOT_CONFIRMED: "Transaction does not have enough confirmation",
    SUCCESS: "Transaction Successful",
    FAILED: "Transaction Unsuccessful"
};
